import drawerSetted from "./drawerSetted";
import selectedLeaveSetted from "./selectedLeaveSetted";

const payrunReducers = { drawerSetted, selectedLeaveSetted };

export default payrunReducers;
